import { useEffect, useState } from "react";
import { wsUrl } from "@/api";

const WS_RECONNECT_MS = 3000;

export function usePresence(currentKeyRef) {
  const [online, setOnline] = useState([]);
  const [refreshKey, setRefreshKey] = useState(0);

  useEffect(() => {
    const handleMessage = (e) => {
      try {
        const msg = JSON.parse(e.data);
        if (msg.type === "presence") setOnline(msg.online);
        if (msg.type === "day-updated" && msg.month === currentKeyRef.current) setRefreshKey((k) => k + 1);
      } catch (err) {
        if (process.env.NODE_ENV !== "production") console.debug("Messaggio WS non JSON ignorato", err);
      }
    };
    let ws;
    let closed = false;
    const connect = () => {
      ws = new WebSocket(wsUrl());
      ws.onmessage = handleMessage;
      ws.onclose = () => { if (!closed) setTimeout(connect, WS_RECONNECT_MS); };
    };
    connect();
    // WebSocket/WS_RECONNECT_MS sono globali/costanti di modulo: la connessione si apre una sola volta per ref
    return () => { closed = true; ws && ws.close(); };
  }, [currentKeyRef]); // eslint-disable-line react-hooks/exhaustive-deps

  return { online, refreshKey };
}
